<template>
    <div class="d-flex justify-content-between progress-des mb-4">
        <a @click="handleClick(1)" :class="currentActiveStep(1, currentStep)">01</a>
        <a @click="handleClick(2)" :class="currentActiveStep(2, currentStep)">02</a>
        <a @click="handleClick(3)" :class="currentActiveStep(3, currentStep)">03</a>
        <a @click="handleClick(4)" :class="currentActiveStep(4, currentStep)">04</a>
    </div>
</template>
<script>
export default {
    name: 'Stepper',
    props: {
        currentStep: {
            type: Number
        },
        finalStep: {
            type: Number
        },
    },
    data() {
        return {};
    },
    methods: {
        currentActiveStep(step, currentStep) {
            if (step === currentStep) {
                return 'active';
            }

            if (step > currentStep) {
                return 'not-clickable'
            }

            return null;
        },
        handleClick(step) {
            if (this.currentStep === this.finalStep) {
                return;
            }

            if (step < this.currentStep) {
                this.$emit('click', step);
            }
        }
    }
}
</script>
<style scoped>

.progress-des a {
    cursor: pointer;
}

.not-clickable {
    cursor: none;
    pointer-events: none;
    user-select: none;
}
</style>
